import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

import styles from "./SidebarBrandLogo.module.css";

type SidebarBrandLogoProps = {
  theme?: "sidebar" | "brandBar";
};

function SidebarBrandLogo({
  theme = "sidebar",
}: SidebarBrandLogoProps): React.JSX.Element {
  const { t } = useTranslation();
  const onBrandBar = theme === "brandBar";

  return (
    <div
      className={clsx(styles.logo, onBrandBar && styles.logoOnBrandBar)}
      aria-label={t("menu.brandLogoAlt")}
    >
      <span className={styles.wordmark}>finanslicenser</span>
    </div>
  );
}

export default SidebarBrandLogo;
